<template>
    <div class="record">
        <z-title title="预定记录" ref="title"></z-title>
        <el-card class="content1" ref="search">
            <div class="flex-n fac">
                <el-button type="primary" class="ele-btn1 mr-10" @click="addOrder">新增预定</el-button>
                <el-input
                        size="medium"
                        class="ele-input mr-10 "
                        placeholder="输入姓名"
                        maxlength="20"
                        clearable
                        title="输入要搜索的姓名"
                        prefix-icon="el-icon-search"
                        v-model="customName">
                </el-input>
                <el-input
                        size="medium"
                        class="ele-input mr-10 "
                        type="number"
                        clearable
                        placeholder="输入电话号码"
                        title="输入电话号码"
                        prefix-icon="el-icon-search"
                        maxlength="11"
                        v-model="phone">
                </el-input>
                <!--<el-input-->
                        <!--size="medium"-->
                        <!--class="ele-input mr-10 "-->
                        <!--type="number"-->
                        <!--clearable-->
                        <!--placeholder="输入销售姓名"-->
                        <!--title="输入销售姓名"-->
                        <!--prefix-icon="el-icon-search"-->
                        <!--maxlength="11"-->
                        <!--v-model="phone">-->
                <!--</el-input>-->
                <div class="textnowrap">套餐类型：</div>
                <package-types class=" mr-10 "  clearable size="medium" v-model="packageIds" placeholder="请选择"></package-types>
                <div class="textnowrap">操作状态：</div>
                <order-confirm-state clearable class="mr-10 " multiple size="medium" v-model="confirmStateList"
                                     placeholder="请选择"></order-confirm-state>
                <div class="textnowrap">预定状态：</div>
                <order-state clearable class="mr-10 " multiple size="medium" v-model="orderState"
                             placeholder="请选择"></order-state>
            </div>
            <!--<div class="flex-n fac mt-10">-->

              <!---->

            <!--</div>-->

            <div class="flex-n fac mt-10">
                <div class="textnowrap">预定日期：</div>
                <el-date-picker
                        size="medium"
                        class="mr-10 date"
                        v-model="dateRange"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                >
                </el-date-picker>

                <div class="textnowrap">场地：</div>
                <want-house class="mr-10 " clearable size="medium" v-model="houseId" placeholder="请选择"></want-house>
                <div class="textnowrap">下单日期：</div>
                <el-date-picker
                        size="medium"
                        class="mr-10 date"
                        v-model="orderDateRange"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                >
                </el-date-picker>
            </div>
            <div class="flex-n fac mt-10">
                <div class="textnowrap">销售：</div>
                <saler-list class="flex-1 mr-10"  clearable size="medium" v-model="createUserCodes" multiple placeholder="请选择销售" ></saler-list>
                <el-button type="primary" class="ele-btn2" @click="searchOrder">查询</el-button>

            </div>
        </el-card>
        <el-card class="mt-10">
            <div class="flex-n fac record-total">
                <div class="mr-20">订单数量：{{info.orderCount||0}}</div>
                <div class="mr-20">完成业绩：{{info.clearMoney||0}}元</div>
                <div class="mr-20">未完成业绩：{{info.unClearMoney||0}}元</div>
                <div class="mr-20">提成：{{info.commissionMoney||0}}元</div>
                <div>定金：{{info.downPayment||0}}元</div>
            </div>
            <el-table
class="mt-20"
                    v-loading="loading"
                    :height="height+'px'"
                    highlight-current-row
                    element-loading-text="列表刷新中"
                    header-cell-class-name="headerrow"
                    cell-class-name="cellclass"
                    :data="dataList"

                    style="width: 100%">
                <el-table-column
                        fixed
                        label="预订状态"
                        width="80"
                        align="center">
                    <template slot-scope="scope">
                        <el-tag size="mini" effect="dark"  v-if="scope.row.orderState=='03'" type="info">{{scope.row.orderStateText}}</el-tag>
                        <el-tag size="mini" effect="dark"  v-if="scope.row.orderState=='02'" type="danger">{{scope.row.orderStateText}}</el-tag>
                        <el-tag size="mini" effect="dark" v-if="scope.row.orderState=='01'" type="success">{{scope.row.orderStateText}}</el-tag>

                    </template>
                </el-table-column>
                <el-table-column
                        fixed
                        label="操作状态"
                        width="80"
                        align="center">
                    <template slot-scope="scope">
                        <el-tag size="mini" effect="plain" v-if="scope.row.confirmState=='04'"  type="warning">{{scope.row.confirmStateText}}</el-tag>
                        <el-tag size="mini" effect="plain"  v-if="scope.row.confirmState=='03'" type="info">{{scope.row.confirmStateText}}</el-tag>
                        <el-tag size="mini" effect="plain"  v-if="scope.row.confirmState=='02'" type="danger">{{scope.row.confirmStateText}}</el-tag>
                        <el-tag size="mini" effect="plain" v-if="scope.row.confirmState=='01'" type="success">{{scope.row.confirmStateText}}</el-tag>

                    </template>
                </el-table-column>
                <el-table-column
                        fixed
                        align="center"
                        prop="customName"
                        label="客户姓名"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="phone"
                        label="电 话"
                        width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="预定日期"
                        width="100"
                        prop="orderDate"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="预定时段"
                        width="110"
                        align="center">
                    <template  slot-scope="scope">
                        {{scope.row.activityBeginTime}}~{{scope.row.activityEndTime}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="houseName"
                        label="预定场地"
                        width="100"
                        align="center">
                </el-table-column>
                <!--<el-table-column-->
                        <!--prop="orderNumber"-->
                        <!--label="预定桌数"-->
                        <!--width="180"-->
                        <!--align="center">-->
                <!--</el-table-column>-->
                <el-table-column
                prop="orderNumber"
                label="预定数量"
                width="120"
                align="center">
                </el-table-column>
                <el-table-column
                        prop="orderNumber"
                        label="实际数量"
                        width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="packageName"
                        label="预定套餐"
                        width="140"
                        align="center">
                </el-table-column>

                <el-table-column
                        prop="downPayment"
                        label="定 金"
                        width="80"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="应收款"
                        min-width="100"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.orderNeedMoney||0}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="实收款"
                        min-width="100"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.realPayment||0}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="差额"
                        min-width="100"
                        align="center">
                    <template slot-scope="scope">
                        {{(scope.row.realPayment||0)-(scope.row.orderNeedMoney||0)-(scope.row.refundMoney||0)}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="提成"
                        min-width="100"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.commissionMoney||0}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="销售"
                        prop="createUserName"
                        min-width="120"
                        align="center">
                </el-table-column>
                <!--<el-table-column-->
                        <!--prop="createUserName"-->
                        <!--label="接待人员"-->
                        <!--width="120"-->
                        <!--align="center">-->
                <!--</el-table-column>-->
                <!--<el-table-column-->
                        <!--prop="createUserPhone"-->
                        <!--label="接待电话"-->
                        <!--width="120"-->
                        <!--align="center">-->
                <!--</el-table-column>-->
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="130"
                        align="center">
                    <template slot-scope="scope">
                        <el-select value="" style="padding: 5px 0" class="ele-select mr-10" size="mini"  placeholder="选择操作" @change="chooseTodo(scope.row.id,$event)"  @visible-change="getSelectList(scope.row,$event)">
                            <el-option
                                    v-for="item in todoOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                            <!--v-if="(scope.row.confirmStateList=='01'||scope.row.confirmStateList=='02')?(scope.row.auth&&scope.row.auth.isDelete=='1'?(item.value!=1):(item.value!=1&&item.value!=5)):(scope.row.auth&&scope.row.auth.isDelete=='1'?(item.value>0):(item.value!=5))"-->

                        </el-select>

                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <pagination :current-page="currentPage" :page-size="pageSize" :total="total"   @sizeChange="handleSizeChange"
                        @currentChange="handleCurrentChange"></pagination>
        </el-card>
        <!--处理明细-->
        <processdetails type-name="预定" :consult-info="consultInfo" :visible.sync="showdetail"></processdetails>
        <!--预定-->
        <books :id="id"  :visible.sync="showreserve" @refresh="refresh"></books>
        <!--查看预定-->
        <view-book :visible.sync="lookOrder"  :id="id" ></view-book>
        <!--查看日志-->
        <view-log :visible.sync="lookLog" type="order"></view-log>
    </div>
</template>

<script>
    import ZTitle from "../../components/ZTitle";
    import Processdetails from "../component/processdetails";

    import Books from "../component/books";
    import WantHouse from "../../components/data/wantHouse";
    import PackageTypes from "../../components/data/packageTypes";
    import Orderbase from "../component/orderbase";
    import Weddingbase from "../component/weddingbase";
    import ViewBook from "./sub/ViewBook";
    import ViewLog from "./sub/ViewLog";
    import OrderConfirmState from "../../components/data/orderConfirmState";
    import Pagination from "../../components/pagination/pagination";
    import OrderState from "../../components/data/orderState";
    import SalerList from "../../components/data/salerList";

    export default {
        components: {
            SalerList,
            OrderState,
            Pagination,
            OrderConfirmState,
            ViewLog,
            ViewBook,
            Weddingbase,
            Orderbase,
            PackageTypes,
            WantHouse,
            Processdetails,
            Books,
            ZTitle},
        name: "record",
        data() {
            return {
                loading: false,
                pageSize: 20,
                currentPage: 1,
                total: 0,
                height: 250,

                showedit: false,
              timeTagList:[],
                dataList: [],

                customName: '',
                phone: '',
                dateRange:[],
                createUserCodes:[],
                orderDateRange:[],
                houseId: '',
                packageIds: '',
                confirmStateList:[],
                orderState:[],
                id:'',

                showdetail:false,

                //操作选择
                todoOptions:[],

                //预定数据
                info:{},

                dataForm:{},
                showreserve:false,//编辑预定
                lookOrder:false,//查看预定
                lookLog:false,//查看日志
                consultInfo:{}
            }
        },
        computed:{
            pickerOptions() {
                var that=this;
                return{
                    firstDayOfWeek: 1,
                    shortcuts: [
                        {
                            text: '今日',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '昨日',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24);
                                end.setTime(end.getTime() - 3600 * 1000 * 24);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '本周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                var num=start.getDay();
                                if(num==0){
                                    num=7;
                                }
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * (num-1));
                                end.setTime(end.getTime() + 3600 * 1000 * 24 * (7-num));
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '上周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                var num=start.getDay();
                                if(num==0){
                                    num=7;
                                }
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * (num+6));
                                end.setTime(end.getTime() - 3600 * 1000 * 24 * num);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '本月',
                            onClick(picker) {
                                const start = new Date();
                                var year=start.getFullYear(),month=start.getMonth()+1;
                                var startDate=new Date(year+'-'+month+'-1');
                                var length=that.$TM.getMonthArea().length-1;
                                var dd=that.$TM.getMonthArea()[length].dd;
                                var endDate= new Date(that.$TM.getMonthArea()[length-(dd<7?dd:0)].date);
                                console.log(startDate,endDate)
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '上月',
                            onClick(picker) {
                                const start = new Date();
                                console.log(that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1}))
                                var month=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[15].mm,
                                    year=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[15].yy;
                                var length=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1}).length-1;
                                var dd=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[length].dd;
                                var startDate=new Date(year+'-'+month+'-1');
                                var endDate= new Date(that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[length-(dd<7?dd:0)].date);
                                // console.log(startDate,endDate)
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        }
                    ]
                }
            },

        },
        mounted(){
            setTimeout(()=>{
                this.height=document.body.offsetHeight -this.$refs.title.$el.offsetHeight-this.$refs.search.$el.offsetHeight - 240;
                console.log(this.height)
            },0)
            var date=this.$TM.getDayArea();
            var mm=date.mm,yy=date.yy;
            if(mm==12){
                mm=1;
                yy++;
            }
            var date2=new Date(new Date(this.$TM.getDayArea(yy,mm+1,1).date).getTime()-24*60*60*1000);            this.dateRange=[date.yy+'-'+date.mm+'-1',date2.getFullYear()+'-'+(date2.getMonth()+1)+'-'+date2.getDate()];
            this.getOrder();
            this.getTotal();
        },
        methods: {
          getTimeRange() {
            this.$axios.get('/config/baseByStoreId/' + this.$root.getStorage('storeId')).then(res => {
              console.log('基本店铺设置信息', res.data)
              let orderTag = [];
              for (let i in res.data.orderTag) {
                orderTag.push(res.data.orderTag[i].beginTime + '~' + res.data.orderTag[i].endTime)
              }
              this.timeTagList = orderTag;
            }).catch(err => {
              this.$message.error(err.msg);
            })
          },
            //刷新列表
            refresh(){
                if(!this.id){
                    this.currentPage=1;
                }
                this.getOrder();
                this.getTotal();
            },
            //统计
            getTotal(){
                this.$axios.post('report/reportOrderSumCalc',{
                    "storeId": this.$root.getStorage('storeId'),
                    "customName": this.customName,
                    "phone": this.phone,
                    "startTime": this.dateRange?this.dateRange[0]:'',
                    "endTime": this.dateRange?this.dateRange[1]:'',
                    "createTimeBegin": this.orderDateRange?this.orderDateRange[0]:'',
                    "createTimeEnd": this.orderDateRange?this.orderDateRange[1]:'',
                    "houseId": this.houseId,
                    "packageIds": this.packageIds,
                    "confirmStateList":this.confirmStateList,
                    "orderStates":this.orderState,
                    "createUserCodes":this.createUserCodes.join(','),
                }).then(res=>{
                    this.info=res.data.list[0];
                }).catch(err=>{

                })
            },
            //预定数据列表查询
            getOrder(){
                this.loading=true;
                // console.log(this.dateRange)
                this.$axios.post('/order/orderList',{
                    "storeId": this.$root.getStorage('storeId'),
                    "customName": this.customName,
                    "currentPage":this.currentPage,
                    "pageSize":this.pageSize,
                    "phone": this.phone,
                    "startTime": this.dateRange?this.dateRange[0]:'',
                    "endTime": this.dateRange?this.dateRange[1]:'',
                    "createTimeBegin": this.orderDateRange?this.orderDateRange[0]:'',
                    "createTimeEnd": this.orderDateRange?this.orderDateRange[1]:'',
                    "houseId": this.houseId,
                    "packageIds": this.packageIds,
                    "confirmStateList":this.confirmStateList,
                    "orderStates":this.orderState,
                    "createUserCodes":this.createUserCodes.join(','),

                }).then(res=>{
                    console.log('预定数据列表', res);
                    var dataList=res.data.list;
                    for(var i in dataList){
                        var content='';
                        for(var j in  dataList[i].payTypes){
                            if(dataList[i].payTypes[j].payTypeCode=='01'){
                                content += (dataList[i].payTypes[j].orderCount||0) +'人、';
                            }
                            if( dataList[i].payTypes[j].payTypeCode=='02'){
                                content += (dataList[i].payTypes[j].orderCount||0) +'桌、';
                            }
                        }
                        if(content.substring(content.length-1,content.length)=='、'){
                            content=content.substring(0,content.length-1)
                        }
                        if(content!=''){
                            if(dataList[i].mainPayType=='03'){
                                dataList[i].orderNumber='包场('+ content +')'
                            }else{
                                dataList[i].orderNumber=content
                            }

                        }
                    }
                    this.dataList=dataList;
                    this.total = res.data.total;
                    this.loading=false;
                }).catch(err=>{
                    this.$message.error(err.msg);
                    this.loading=false;
                })
            },
            //搜索
            searchOrder() {
                this.currentPage = 1;
                this.getOrder();
                this.getTotal();
            },
            addOrder(){
                this.showreserve=true;
                this.id='';
            },
            //处理明细
            getDetail(){
                this.showdetail=true;
            },
            //下拉列表功能
            getSelectList(row,show){
                console.log(show)
                if(show){
                    var todoOptions=[{
                        value: '1',
                        label: '编辑预定'
                    }, {
                        value: '2',
                        label: '查看预定'
                    },  {
                        value: '3',
                        label: '查看处理明细'
                    }, {
                        value: '4',
                        label: '复制预定'
                    },{
                        value: '5',
                        label: '取消预订'
                    },{
                        value:'6',
                        label:'查看日志'
                    }
                    ];
                    //非当前登录人，没有编辑权限，只能查看 3，6

                    if(row.createUserCode!=this.$root.getStorage('info').userId&&this.$root.getStorage('menuAuth').isEditOther=='0'){

                        for(var i=0;i<todoOptions.length;i++){
                            if(todoOptions[i].value!='3'&&todoOptions[i].value!='6'){
                                todoOptions.splice(i,1);
                                i--;
                            }
                        }
                    }
                    //已完成 已关闭 不能编辑
                    if(row.confirmState=='01'||row.confirmState=='02'){
                        for(var i in todoOptions){
                            if(todoOptions[i].value=='1'){
                                todoOptions.splice(i,1);
                                break;
                            }
                        }
                    }
                    if(row.auth&&row.auth.isDelete!='1'||row.confirmState=='01'||row.confirmState=='02'){
                        for(var i in todoOptions){
                            if(todoOptions[i].value=='5'){
                                todoOptions.splice(i,1);
                                break;
                            }
                        }
                    }

                    this.todoOptions=todoOptions;
                }

            },
            chooseTodo(id,num){
                this.id=id;
                this.$axios.get('/order/orderDetailById/'+id).then(res=>{
                    console.log('根据id查询订单的信息',res)
                    // var dataForm=res.data;
                    // if(dataForm.orderState!='02'){
                    //     dataForm.phone2=dataForm.phone;
                    // }
                    // this.dataForm=dataForm;
                    //编辑预定
                    if(num==1){
                        this.showreserve=true;
                    }
                    //查看预定
                    if(num==2){
                        this.lookOrder=true;
                    }
                    var info=res.data;
                    // this.info=info;
                    //处理明细
                    if(num==3){
                        this.consultInfo={
                            customName:info.customName,
                            phone:info.phone,
                            wechatNo:info.wechatNo,
                            list:info.orderFollowList
                        };
                        this.getDetail();
                    }
                    if(num==5){
                        var that=this;
                        this.$confirm('是否取消该订单?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            that.$axios.post('order/cancelByIds/',id).then(res=>{
                                that.$message.success('订单取消成功!');
                                that.getOrder();
                            }).catch(err=>{
                                that.$message.error(err.msg);

                            })
                        }).catch(() => {

                        });
                    }
                    //复制预定
                    if(num==4){
                        var content='';
                        var packageContent='',orderExtraContent='',payContent='';
                        //套餐文字
                        for(var i in info.orderPackage.itemsExs){
                            packageContent +=info.orderPackage.itemsExs[i].itemName+'、';
                        }
                        for(var i in info.orderPackage.itemsFoods){
                            packageContent +=info.orderPackage.itemsFoods[i].foodName+'、';
                        }
                        if(packageContent.substring(packageContent.length-1,packageContent.length)=='、'){
                            info.packageContent=packageContent.substring(0,packageContent.length-1)
                        }
                        //额外项目文字
                        for(var i in info.orderExtra.itemsExs){
                            orderExtraContent +=info.orderExtra.itemsExs[i].itemName+':'+info.orderExtra.itemsExs[i].itemPrice+'*'+info.orderExtra.itemsExs[i].itemCount+'、';
                        }
                        for(var i in info.orderExtra.itemsFoods){
                            orderExtraContent +=info.orderExtra.itemsFoods[i].foodName+':'+info.orderExtra.itemsFoods[i].foodPrice+'*'+info.orderExtra.itemsFoods[i].foodCount+'、';
                        }
                        if(orderExtraContent.substring(orderExtraContent.length-1,orderExtraContent.length)=='、'){
                            info.orderExtraContent=orderExtraContent.substring(0,orderExtraContent.length-1)
                        }
                        var payTypes=info.payTypes;
                        payTypes.sort((a,b)=>{
                            return Number(b.payTypeCode)-Number(a.payTypeCode);
                        })
                        for(var i in payTypes){
                            if(payTypes[i].payTypeCode=='03'){
                                payContent +='包场费用：'+(payTypes[i].housePrice||0)+'\n';
                            }
                                if(payTypes[i].payTypeCode=='02'){
                                    payContent +='预定桌数：'+(payTypes[i].orderCount||0)+'\n';
                                    payContent +='每桌单价：'+(payTypes[i].onePrice||0)+'\n';
                                }
                                if(payTypes[i].payTypeCode=='01'){
                                    payContent +='预定人数：'+(payTypes[i].orderCount||0)+'\n';
                                    payContent +='每人单价：'+(payTypes[i].onePrice||0)+'\n';
                                }
                        }
                      let activityBeginTime = this.getFormatTimeText(info.activityBeginTime);
                      let activityEndTime = this.getFormatTimeText(info.activityEndTime);
                      let idx = this.timeTagList.indexOf(info.activityBeginTime + '~' + info.activityEndTime);
                      // let labelText = idx > -1 ? this.tagList[idx].tagName :(activityBeginTime+'~'+activityEndTime);
                      let labelText = activityBeginTime+'~'+activityEndTime;//2022-05-04宋哥要求显示时间段 不用改成标签

                        //复制未处理
                        content = this.$store.state.storeName + '预定单' + '\n' +
                            '客户名称：' + info.customName + '\n' +
                            '客户电话：' + (info.phone || '无') + '\n' +
                            '订单日期：' + info.orderDate + '\n' +
                            '预定时段：' + labelText + '\n' +
                            '预定场地：' + info.houseName + '\n' +
                            (info.packageName ? ('套餐名称：' + info.packageName + '\n' +
                                (info.packageContent ? ('           （' + info.packageContent + '）\n') : '')) : '') +
                            payContent +
                            (orderExtraContent.length > 0 ? ('增加项目：' + info.extraRealMoney + '\n') : '') +
                            (info.orderExtraContent ? '           （' + info.orderExtraContent + '）\n' : '') +
                            '已交订金：' + info.downPayment + '\n' +
                          '下单日期：' + info.createTime.substring(5,16) + '\n' +  //2022-05-04宋哥要求改成月日时分格式
                          '接待人员：' + info.createUserName + '\n' +
                            (info.createUserPhone?('接待电话：' + info.createUserPhone  + '\n'):'')+
                            '订单备注：' + (info.remark ? info.remark : '无') + '\n';
                        console.log(content)
                        this.$copyText(content).then((e)=> {
                            this.$message.success('已复制到剪贴板');
                            // console.log(e)
                        }, (err)=> {
                            this.$message.success('复制失败');
                            // console.log(err)
                        })
                    }
                   // 查看日志
                    if(num==6){
                        this.lookLog=true;
                    }
                }).catch(err=>{
                    this.$message.error(err.msg);
                })

            },
            handleSizeChange(val) {
                this.pageSize=val;
                this.getOrder();
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.currentPage=val;
                this.getOrder();
                console.log(`当前页: ${val}`);
            },
          getFormatTimeText(time) {
            let ytime = Number(time.replace(':', ''));
            var c1 = Number(ytime / 100).toFixed(0)
            c1 = c1 < 10 ? ('0' + c1) : (c1 > 23 ? ('次日' + ((c1 - 24) > 9 ? (c1 - 24) : ('0' + (c1 - 24)))) : c1);
            c1 = c1 + ':' + (ytime % 100 ? '30' : '00')
            return c1;
          },
        },
    }
</script>

<style scoped lang="scss">
    .record {
        .content1 {
            .textnowrap {
                font-size: 13px;
                color: #333;
            }
            .date {
                min-width: 100px;
            }
        }
        .record-total{
            &>div{
                font-size: 15px;
                color: #333333;
                font-weight: bold;
            }

        }
    }
</style>
